import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="13.75" height="13.75" viewBox="0 0 13.75 13.75">
  <path d="M3.125-14.375V-3.75h2.5V-5H4.375v-8.125H12.5v1.25h1.25v-2.5ZM6.25-11.25V-.625H16.875V-11.25ZM7.5-10h8.125v8.125H7.5Z" transform="translate(-3.125 14.375)"/>
</svg>
  )
